<template>
  <CadastroBase
    nomePlural="PedidoUniformes"
    nomeSingular="PedidoUniforme"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-dialog
      v-model="formRemoveProduto"
      persistent
      max-width="350"
      class="dialog-deletado"
      content-class="pedido-processo-dialog"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t("Confirma_exclusao?") }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            text
            @click="formRemoveProduto = false"
          >
            {{ $t("nao") }}
          </v-btn>

          <v-btn
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            height="39"
            text
            @click="removeProduto()"
          >
            {{ $t("Confirmar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="formAddProduto"
      persistent
      max-width="350"
      content-class="pedido-processo-dialog"
    >
      <v-card>
        <v-form @submit.prevent="addProduto">
          <v-card-title class="headline">
            {{ $t("Adicionar_produto") }} <br />
            <v-btn
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
            >
              {{ this.produto.descricao }} - {{ this.produto.tamanho }}
            </v-btn>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  type="number"
                  :label="$t('Quantidade')"
                  v-model="quantidadeSolicitada"
                  min="1"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              height="39"
              class="
                font-weight-bold
                text-capitalize
                btn-ls btn-secondary
                bg-gradient-light
                py-3
                px-6
              "
              @click="limpaFormProduto"
            >
              {{ $t("Cancelar") }}
            </v-btn>

            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click.prevent="addProduto"
            >
              {{ $t("Adicionar") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-col cols="12" class="pedido-processo">
      <PedidoProcessoIntroducao
        titulo="Monte o pedido de uniforme"
        descricao="Selecione o destinatário, encontre as peças e tamanhos corretos e confira as quantidades antes de enviar."
        icon="mdi-tshirt-crew-outline"
      />
      <v-row>
        <v-col cols="6" md="6" class="d-flex">
          <CampoData
            @date="dataPedido = $event"
            :label="$t('Data')"
            id="dataPedido"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            id="observacao"
            v-model="observacao"
            :label="$t('Observacao')"
            name="observacao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>
        <!-- <v-col cols="6" md="6" class="d-flex">
            <CampoData
              @date="dataRetorno = $event"
              :label="$t('Previsao_retorno')"
            />
          </v-col> -->
        <v-col v-if="permiteVinculoPessoa" cols="12">
          <v-btn-toggle
            v-model="tipoVinculo"
            mandatory
            color="primary"
            class="tipo-vinculo-toggle"
          >
            <v-btn value="FUNCIONARIO" class="text-none">
              <v-icon left>mdi-badge-account-outline</v-icon>
              {{ $t("Funcionario") }}
            </v-btn>
            <v-btn value="PESSOA" class="text-none">
              <v-icon left>mdi-account-outline</v-icon>
              {{ $t("Pessoa") }}
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col v-if="tipoVinculo === 'FUNCIONARIO'" cols="12">
          <BuscaSelecionaFuncionario
            v-model="selectedFuncionario"
            :headers="headersFuncionario"
            :data-service="DataService"
            fetch-method="getFuncionarios"
            item-key="funcionario.matricula"
          />
        </v-col>
        <v-col v-else cols="12">
          <TabelaSelecionaPessoa
            titulo="Pessoa"
            :carregar-pessoas="carregarPessoas"
            @pessoa="selecionarPessoa"
          />
        </v-col>

        <PedidoProdutosSeletor
          v-model="pedido"
          :produtos="produtos"
          titulo-catalogo="Catálogo de uniformes"
          product-icon="mdi-tshirt-crew-outline"
          :mostrar-tamanho="true"
          :mostrar-codigo-barras="true"
          :mostrar-estoque="true"
        />

        <v-col cols="12"> </v-col>
      </v-row>
    </v-col>
  </CadastroBase>
</template>

<script>
import CadastroBase from "@/components/base/Crud/CadastroBase";
import BuscaSelecionaFuncionario from "@/components/base/proprios/BuscaSelecionaFuncionario";
import TabelaSelecionaPessoa from "@/components/base/proprios/TabelaSelecionaPessoa";
import PedidoProcessoIntroducao from "@/components/recursos/pedido-layout/PedidoProcessoIntroducao";
import PedidoProdutosSeletor from "@/components/recursos/pedido-layout/PedidoProdutosSeletor";
import DataService from "@/services/recursos/PedidoUniformeDataService";
export default {
  name: "CadastroPedido",
  components: {
    CadastroBase,
    BuscaSelecionaFuncionario,
    TabelaSelecionaPessoa,
    PedidoProcessoIntroducao,
    PedidoProdutosSeletor,
  },
  data() {
    return {
      DataService: DataService,
      DeveLimparForm: true,
      submited: false,
      dataPedido: "",
      dataDevolucao: "",
      descricao: "",
      observacao: "",
      funcionario: {},
      pessoa: null,
      tipoVinculo: "FUNCIONARIO",

      pedido: [],
      produtos: [],
      search: "",
      searchPedido: "",
      errors: [],
      produto: {},
      formAddProduto: false,
      formRemoveProduto: false,
      quantidadeSolicitada: 0,
      headers: [
        {
          text: this.$t("Descricao"),
          value: "descricao",
          align: "start",
          sortable: "false",
        },
        {
          text: this.$t("Tamanho"),
          value: "tamanho",
          align: "start",
          sortable: "false",
        },
        // { text: this.$t("Valor"), value: "valor", sortable: "true" },
        // { text: this.$t("Estoque"), value: "estoque", sortable: "true" },
        // { text: this.$t("Status"), value: "status", sortable: "false" },
        { text: this.$t("cbarras"), value: "cbarras", sortable: "true" },
      ],
      selectedFuncionario: [],
      headersFuncionario: [
        { text: this.$t("Matricula"), value: "funcionario.matricula" },
        { text: this.$t("Nome"), value: "funcionario.pessoa.nome" },
        {
          text: this.$t("Sindicato"),
          value: "funcionario.sindicato.descricao",
        },
        { text: this.$t("Cargo"), value: "funcionario.cargo.descricao" },
        {
          text: this.$t("PostoTrabalho"),
          value: "funcionario.postoTrabalho.descricao",
        },
      ],

      headersPedido: [
        {
          text: this.$t("Descricao"),
          value: "produto.descricao",
          align: "start",
          sortable: "false",
        },
        {
          text: this.$t("Tamanho"),
          value: "produto.tamanho",
          align: "start",
          sortable: "false",
        },
        {
          text: this.$t("quantidadeSolicitada"),
          value: "quantidadeSolicitada",
          sortable: "false",
        },
        {
          text: this.$t("cbarras"),
          value: "produto.cbarras",
          sortable: "true",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
    };
  },
  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
    limpaForm() {
      this.pedido = [];
      this.dataPedido = "";
      this.dataDevolucao = "";
      this.observacao = "";
      this.descricao = "";
      this.funcionario = {};
      this.pessoa = null;
      this.selectedFuncionario = [];
    },

    getProdutos() {
      DataService.getProdutos().then((response) => {
        this.produtos = response.data;
      });
    },
    handleClick(event) {
      this.produto = event;
      this.formAddProduto = true;
    },
    addProduto() {
      var produtoExistente = this.pedido.find(
        (produto) => produto.produto.id == this.produto.id
      );
      if (produtoExistente) {
        this.quantidadeSolicitada =
          parseInt(this.quantidadeSolicitada) +
          parseInt(produtoExistente.quantidadeSolicitada);
        this.pedido = this.pedido.filter((produto) => {
          return produto.produto.id !== produtoExistente.produto.id;
        });
      }
      this.pedido.push({
        produto: this.produto,
        quantidadeSolicitada: this.quantidadeSolicitada,
      });
      this.produto = {};
      this.quantidadeSolicitada = 0;
      this.search = "";
      this.formAddProduto = false;
      console.log("searchProdutos", this.$refs.searchProdutos);
      this.$refs.searchProdutos.focus();
    },
    limpaFormProduto() {
      this.formAddProduto = false;
      this.quantidadeSolicitada = 0;
    },
    confirmaRemoveProduto(item) {
      this.produto = item.produto;
      this.formRemoveProduto = true;
    },
    removeProduto() {
      this.pedido = this.pedido.filter((produto) => {
        return produto.produto.id !== this.produto.id;
      });
      this.formRemoveProduto = false;
      this.$swal.fire(this.$t("Removido_com_sucesso"), "", "success");
    },
    selecionarPessoa(pessoa) {
      this.pessoa = pessoa && pessoa.id ? { id: pessoa.id } : null;
    },
    carregarPessoas(payload = {}) {
      return DataService.getPessoas(String(payload.nomeCpf || "").trim());
    },
  },

  mounted() {
    this.getProdutos();
    this.getClientes();
  },
  computed: {
    recurso: function () {
      return {
        dataPedido: this.dataPedido,
        dataRetorno: this.dataRetorno,
        observacao: this.observacao,
        descricao: this.descricao,
        items: this.pedido,
        funcionario: this.funcionario,
        pessoa: this.pessoa,
      };
    },

    permiteVinculoPessoa() {
      const parametrizacoes =
        this.$store?.state?.inquilino?.parametrizacoes || [];
      return parametrizacoes.some(
        (item) =>
          item &&
          item.tipo === "UNIFORMEPERMITIRVINCULOPESSOA" &&
          item.ativo === true
      );
    },

    agora: function () {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate().toString().padStart(2, "0");
      return date + "T00:00";
    },
  },
  watch: {
    selectedFuncionario(newVal) {
      if (newVal.length > 0) {
        this.funcionario = { id: newVal[0].funcionario.id };
      } else {
        this.funcionario = null;
      }
    },
    tipoVinculo(newVal) {
      if (newVal === "PESSOA") {
        this.selectedFuncionario = [];
        this.funcionario = null;
      } else {
        this.pessoa = null;
      }
    },
  },
  beforeInsert() {
    if (this.tipoVinculo === "PESSOA") {
      this.funcionario = null;
    } else if (this.selectedFuncionario.length > 0) {
      this.funcionario = {
        id: this.selectedFuncionario[0].funcionario.id,
      };
    } else {
      this.funcionario = null;
    }
    return this.recurso;
  },
};
</script>
<style scoped>
#data {
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 99px;
}
.mdl-textfield:not(.is-dirty) input::-webkit-datetime-edit {
  color: transparent;
}
input:focus::-webkit-datetime-edit {
  color: rgba(255, 255, 255, 0.46) !important;
}

.tipo-vinculo-toggle {
  overflow: hidden;
  border: 1px solid #d0d5dd;
  border-radius: 4px;
}

.tipo-vinculo-toggle ::v-deep .v-btn {
  opacity: 1;
}

.tipo-vinculo-toggle ::v-deep .v-btn:not(.v-btn--active) {
  color: #475467 !important;
  background: #ffffff !important;
}

.tipo-vinculo-toggle ::v-deep .v-btn--active {
  color: #ffffff !important;
  background: #1d7af8 !important;
  box-shadow: 0 4px 10px rgba(29, 122, 248, 0.28) !important;
}

.tipo-vinculo-toggle ::v-deep .v-btn--active .v-icon {
  color: #ffffff !important;
}
</style>
